const DocumentConst = {
  // Disable placement editing without overwriting stored values.
  zoningEnabled: true,
  // Adding a placement here also requires a corresponding consumer in the app.
  zones: [
    {
      placement: "additional_menu",
      labelKey: "APP_SETTINGS.Zone_AdditionalMenu",
      descriptionKey: "APP_SETTINGS.Zone_AdditionalMenu_Help",
    },
  ],
};

export default DocumentConst;
